import type {PropsWithChildren} from 'react';
import React from 'react';
import clsx from 'clsx';

/**
 * Parent component need "@container" class for media queries
 */
export const GridList = ({children}: PropsWithChildren) => {
	return <ul className={clsx('grid', '@3xl:grid-cols-3', 'gap-4', '@3xl:gap-10')}>{children}</ul>;
};
